<template>
    <g
        class="x-axis line"
        :transform="`translate(${boundary.minX}, ${boundary.maxY})`"
    >
        <line
            :x1="boundary.minX"
            :x2="boundary.maxX - boundary.padding"
            :y1="0"
            :y2="0"
            :stroke="strokeColor"
        >
        </line>
    </g>
</template>

<script>
export default {
    props: [
        'boundary',
        'strokeColor'
    ]
}
</script>

<style>

</style>
